



























import { Component, Vue, Prop } from 'vue-property-decorator'
import { GoogleMapMarker } from "@/pitprojekt/types";
import { EventBus } from "@/pitprojekt/event-bus";
import GoogleMap from "@/components/GoogleMap.vue";
import { Geoloc } from "@/pitprojekt/models/Geoloc";
import { GeoIPService } from "@/services/geoip.service"

@Component({
  components: { GoogleMap }
})
export default class GoogleMapDialog extends Vue {
  dialog: boolean  = false;
  geoloc: Geoloc = <Geoloc>{};
  loading: boolean = false;

  created() {
    EventBus.$on('showGoogleMapDialogEvent', this.setGeolocAndshowDialog);
    EventBus.$on('showGoogleMapDialogByIPEvent', this.getGeolocByIPAndShowDialog);
  }

  async getGeolocByIPAndShowDialog(ip: string) {
    this.loading = true;
    this.showDialog();
    this.geoloc = await GeoIPService.getGeolocByIP(ip);
    this.loading = false;
  }

  setGeolocAndshowDialog(geoloc: Geoloc) {
    this.geoloc = geoloc;
    this.showDialog();
  }

  showDialog() {
    this.dialog = true;
    EventBus.$emit('googleMapDialogShowEvent');
  }

  closeDialog() {
    EventBus.$emit('googleMapDialogCloseEvent');
    this.dialog = false;
    this.geoloc = <Geoloc>{};
  }

  get getMarkers() {
    return [{
      'position': {
        lat: this.geoloc.lat,
        lng: this.geoloc.lon
      }
    }];
  }

}
